import { render, staticRenderFns } from "./MinMaxDisplay.vue?vue&type=template&id=567f0022&scoped=true&"
import script from "./MinMaxDisplay.vue?vue&type=script&lang=js&"
export * from "./MinMaxDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567f0022",
  null
  
)

export default component.exports